import React, { Component } from 'react'
import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";
export class ContactPage extends Component {
    render() {
        return (
            <div>
                <Navbar></Navbar>
                <div>
                    contact page
                </div>
                <Footer></Footer>
            </div>
        )
    }
}

export default ContactPage
